@if (settings$ | async; as settings) {
	<header>
		<stages-button
			[buttonType]="'button'"
			[title]="'back'"
			[iconClasses]="'ico-chevron-left-small'"
			[buttonClasses]="'menu-button'"
			[showIconOnly]="true"
			(clicked)="closeButtonPressed.emit()"
		>
		</stages-button>
		<span (click)="closeButtonPressed.emit()" translate="back" class="h3 pointer"></span>
	</header>
	<div class="tab-container">
		<stages-tabs [disbaleScrolling]="true">
			@if (settings.historyEnabled) {
				<stages-tab-no-route
					[active]="activeContainer === ChatbotChildContainer.HISTORY"
					(activate)="openChildContainer(ChatbotChildContainer.HISTORY, ChatbotChildContainer.SETTINGS)"
				>
					<span stagesCardTitle class="h5" translate="chatbot.history"></span>
				</stages-tab-no-route>
			}
			<stages-tab-no-route
				[active]="activeContainer === ChatbotChildContainer.SETTINGS"
				(activate)="openChildContainer(ChatbotChildContainer.SETTINGS, ChatbotChildContainer.HISTORY)"
			>
				<span stagesCardTitle class="h5" translate="settings"></span>
			</stages-tab-no-route>
			<div class="spacer"></div>
			<stages-menu
				[ngClass]="{ 'hidden-menu': settingsOpen }"
				class="action"
				menuId="muChatHistory"
				iconClasses="ico ico-more-vertical"
				openTo="left"
				[items]="historyMenuItems"
				[noCollapse]="true"
			>
			</stages-menu>
		</stages-tabs>
	</div>
	<div class="chatbot-panel">
		<div class="view-container-parent">
			@if (settings.historyEnabled) {
				<div class="view-container-child" id="history">
					<stages-chatbot-history (chatSelected)="reloadChatbot()" (chatsDeleted)="onChatsDeleted($event)">
					</stages-chatbot-history>
				</div>
			}
			@if (settingsOpen) {
				<div class="view-container-child" id="settings">
					<stages-chatbot-settings [settings$]="settings$"> </stages-chatbot-settings>
				</div>
			}
		</div>
	</div>
}
